import Swal from 'sweetalert2'

import toastr from '@modules/toastr'
import countries from '@constants/countries'
import nationalities from '@constants/nationalities'
import ENV from '@constants/env'
import passportPhotoExample from '@helpers/passport-photo-example'
import SERVICE_PROPS from '@helpers/extract-service-props'

const resource = '/vacancy_notices'
const form_key = 'vacancy_notice'
const fee = 50
const skip_location = true

const hide_buttons = {
  status: true,
  deny: !$app.hasRole('dol_director'),
}

const payUnits = {
  Hourly: 'Hour',
  Weekly: 'Week',
  Annual: 'Annum.',
}

const filter = r => {
  if ($app.hasRole('dol_assistant')) {
    return r.application_decision == 'pending'
  }

  if ($app.hasRole('dol_director')) {
    return r.application_decision == 'processing'
  }

  if ($app.hasRole('dol_pes')) {
    return r.deferred_role == 'PES'
  }

  if ($app.hasRole('dol_osa')) {
    return r.deferred_role == 'OSH'
  }

  return true
}

const fields = form => [
  {
    name: 'renewal',
    type: 'select:bool',
    hide: true,
    view: true,
  },
  {
    heading: 'Business Details',
    hide: form.client_type !== 'business',
  },
  {
    name: 'company_name',
    label: 'Company Registered Name',
    hide: form.client_type !== 'business',
    disabled: true,
  },
  {
    name: 'bl_number',
    label: 'Business Licence Number',
    is: 'integer',
    hide: form.client_type !== 'business',
    required: false,
    disabled: true,
  },
  {
    name: 'tin_number',
    label: 'TIN#',
    is: 'integer',
    disabled: true,
    hide: form.client_type !== 'business',
  },
  {
    name: 'company_email',
    label: 'Company email address',
    view: false,
    hide: form.client_type !== 'business',
    disabled: true,
  },
  {
    name: 'street_address',
    hide: form.client_type !== 'business',
  },
  {
    name: 'po_box',
    label: 'P.O. Box',
    hide: form.client_type !== 'business',
    save: true,
  },
  {
    name: 'phone_number',
    label: 'Telephone Number',
    type: 'phone',
    hide: form.client_type !== 'business',
  },
  {
    name: 'business_type',
    label: 'Type of Business',
    view: false,
    hide: form.client_type !== 'business',
  },
  {
    name: 'business_nib',
    label: 'Business NIB#',
    hide: form.client_type !== 'business',
    // disabled: true,
  },
  {
    name: 'ownership',
    options: [
      'Government',
      'Private',
      'Local',
      'Foreign',
      'Incorporated',
      'Non Profit',
    ],
    view: false,
    hide: form.client_type !== 'business',
  },
  {
    name: 'number_of_employees',
    label: 'Current Number of Employees',
    is: 'integer',
  },
  {
    name: 'number_of_bahamians',
    is: 'integer',
    callback: v => {
      if (form.number_of_employees) {
        return { number_of_non_bahamians: form.number_of_employees - v }
      }
    },
  },
  {
    name: 'number_of_non_bahamians',
    label: 'Number of Non - Bahamians',
    is: 'integer',
  },
  ':: Position Details',
  {
    name: 'expected_hours_of_work',
    label: 'Hours of Work',
    options: [
      { value: '20 or less', label: '20 hours or less (per week)' },
      { value: '21 - 34', label: '21 - 34 hours (per week)' },
      { value: '35 or more', label: '35+ hours (per week)' },
    ],
  },
  {
    name: 'work_duration',
    label: 'Duration',
    options: ['Part-Time', 'Full-Time', 'Permanent', 'Temporary'],
  },
  {
    name: 'pay_unit',
    options: [
      { value: 'Hourly', label: 'Hourly Wage' },
      { value: 'Weekly', label: 'Weekly Wage' },
      { value: 'Annual', label: 'Annual Wage' },
    ],
  },
  {
    name: 'salary',
    label: 'Salary/Wages Per ' + (payUnits[form.pay_unit] ?? 'Period'),
    is: 'curency',
    view: {
      value: amt => `$${(+amt).toFixed(2)} Per ${payUnits[form.pay_unit]}`,
    },
  },
  'job_title',
  {
    name: 'job_desc',
    type: 'textarea',
    label: 'Job Description',
  },
  {
    name: 'duty_details',
    label: 'Details of Duties',
    type: 'textarea',
  },
  {
    key: 'image.4',
    name: 'details_of_duty_upload',
    label: 'Upload of Details of Duties',
    type: 'file:all',
    required: false,
  },
  '::Employee Details (On behalf of whom the application is made)',
  {
    name: 'employee_first',
    label: 'First Name of Employee',
  },
  {
    name: 'employee_middle',
    label: 'Middle Name of Employee',
    required: false,
  },
  {
    name: 'employee_last',
    label: 'Last Name of Employee',
  },
  {
    name: 'employee_age',
    label: 'Age of Employee',
    is: 'integer',
  },
  {
    name: 'employee_gender',
    label: 'Gender',
    options: [
      { label: 'Male', value: 'male' },
      { label: 'Female', value: 'female' },
    ],
  },
  {
    name: 'pickup_location',
    save: true,
    label: 'Island',
    options: [
      'New Providence',
      'Andros',
      'Abaco',
      'Grand Bahama',
      'Exuma',
      // 'Bimini'
    ],
  },
  {
    name: 'nationality',
    options: nationalities,
  },
  {
    key: 'image.10',
    name: 'passport_upload',
    label: 'Passport Photo',
    type: 'file:image',
    hint: passportPhotoExample,
  },
  {
    name: 'country_of_origin',
    options: countries,
  },
  {
    name: 'education',
    options: ['Primary', 'Secondary', 'High School', 'College'],
  },
  {
    name: 'academic_qualifications',
    label: 'List of Academic Qualifications',
    columns: [{ name: 'qualifications', label: 'Qualifications' }],
  },
  {
    name: 'professional_experience',
    label: 'List of Professional Experiences',
    columns: [{ name: 'experience', label: 'Experience' }],
  },
  '::SPACER',
  {
    name: 'bahamians_training',
    columns: [
      { name: 'first_name', label: 'First name' },
      { name: 'middle_initial', label: 'Middle Initial', width: 32 },
      { name: 'last_name', label: 'Last Name' },
      { name: 'date', label: 'Training Start Date', type: 'date' },
    ],
  },

  '::SPACER',
  {
    name: 'incorporation_cert_upload',
    label: 'Job Advertisement',
    type: 'file:all',
    key: 'image.1',
    hint: `
      Please upload evidence of the 3 day newspaper advertisement of the
      vacant position. If the advertisement was posted electronically,
      kindly provide a PDF or screenshot of the ads showing
      the relevant URL/link web address where posted.
    `,
  },
  {
    key: 'image.6',
    name: 'job_advertisement_2_upload',
    type: 'file:all',
    label: 'Additional Job Ad',
    required: false,
  },
  {
    key: 'image.7',
    name: 'job_advertisement_3_upload',
    type: 'file:all',
    label: '2nd Additional Job Ad',
    required: false,
  },
  {
    name: 'waiver_upload',
    label: 'Receipt for Job Ad',
    type: 'file:all',
    key: 'image.2',
  },
  {
    name: 'declaration',
    label:
      'By clicking this box, I confirm that I understand my obligations under the respective laws and regulations applicable to the labour certificate to observe all applicable laws, regulations, policies and guidelines.',
    type: 'checkbox',
  },
]

const hidden_fields = () => [
  {
    key: 'image.11',
    name: 'osh_report',
    type: 'file:pdf',
    admin: true,
  },
  {
    name: 'pdf_upload',
    type: 'file:pdf',
    label: 'Labour Certificate',
    key: 'image.0',
  },
]

const common = component => {
  const custom_actions = [
    {
      text: 'Approve Application',
      icon: 'check-square',
      roles: ['dol_director'],
      test: r => r.application_decision === 'processing',
      fn: approve.bind(component),
    },
    {
      text: 'Defer Application',
      icon: 'file-import',
      roles: ['dol_director'],
      test: r => r.application_decision === 'processing',
      fn: defer.bind(component),
    },
    {
      text: 'Submit to Director',
      icon: 'user-tie',
      roles: ['dol_assistant'],
      fn: submit.bind(component),
    },
    {
      text: 'Send Note to Director',
      icon: 'user-tie',
      roles: [['dol_assistant', 'dol_osa', 'dol_pes']],
      fn: note,
    },
    {
      text: 'Upload OSH Report',
      icon: 'file-alt',
      roles: [['dol_osa', 'dol_pes']],
      fn: upload.bind(component),
    },
  ]

  return SERVICE_PROPS({
    ...component,
    filter_records:
      typeof component.filter_records == 'function'
        ? r => component.filter_records(r) && filter(r)
        : filter,
    fields,
    hidden_fields,
    custom_actions,
    resource,
    form_key,
    fee,
    skip_location,
    hide_buttons,
  })
}

export default common

async function approve (record) {
  const { isConfirmed } = await Swal.fire({
    title: 'Approve Application',
    text: `
    Are you sure that you would like to approve this application?
    By clicking "Confirm", you are acknowleding that you have reviewed this
    application and are satisfied with its contents. Would you like to approve?
    `,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Confirm',
  })

  if (!isConfirmed) return
  this.setState({ loading: true })

  const { props } = this
  const { history, location } = props
  const { axios } = $app

  try {
    await axios.put(resource + '/update_application', {
      [form_key]: {
        form_num: record.form_num,
        application_decision: 'approved',
      },
    })

    if (location.state?.view) {
      const view = { ...location.state.view }
      view.application_decision = 'approved'

      history.replace(location.pathname, { ...location.state, view })
    }

    toastr.success('Success', 'Application successfully approved')
  } catch (error) {
    console.error(error)
    toastr.error('Error', 'Unable to approve application')
    return
  }

  try {
    await axios.post('/emails', {
      email: record.user.email,
      subject: 'MyGateway Portal Update - Vacancy Notice',
      message: `
        Dear ${record.user.first_name.capitalize()},
        <br/>
        Congratulations! Your application for a Vacancy Notice certificate has been approved.
        <br/>
        <br/>
        Thank you for using the MyGateway Portal.
      `,
    })

    toastr.success('Success', 'Confirmation email successfully sent')

    try {
      const { data } = await $app.axios.get('/services/all_paid_forms', {
        params: { service_type: this.service_type || props.service.type },
      })

      const updated_record = data.paid_forms.filter(d => d.id === record?.id)[0]

      await $app.axios.post('/emails', {
        email: record.user.email,
        subject: `MyGateqway Portal Update -  Vacancy Notice`,
        message: `
          Good day ${record.user.first_name.capitalize()},
          <br/>
          Your application for a Vacancy Notice has been approved. As promised, below is a link to your downloadable PDF Permit.
          <br/><br />
          <p><b>Links</b></p>
          <ul>
          <li><a href='${`${ENV.WEB_SERVICE_URL}${updated_record?.image[0]}`}' target='_blank'>Vacancy Notice</a></li>
          </ul>
          <br/><br/>
          Thank you for using MyGateway Portal.
        `,
      })
    } catch (error) {
      toastr.error('Error', 'Unable to send permit email')
      console.error(error)
    }
  } catch (err) {
    console.error(err)
    toastr.error('Error', 'Unable to send email')
  }

  this.setState({ loading: false })
}

async function defer (record) {
  const { value: role } = await Swal.fire({
    title: 'Select Agency',
    input: 'select',
    inputOptions: {
      OSH: 'OSH',
      PES: 'PES',
    },
    showCancelButton: true,
  })

  if (!role) return

  const { value: message } = await Swal.fire({
    input: 'textarea',
    inputLabel: `Message to ${role}`,
    inputPlaceholder: 'Type your message here...',
    inputAttributes: {
      'aria-label': 'Type your message here',
    },
    showCancelButton: true,
    confirmButtonText: 'Send',
  })

  if (!message) return

  try {
    const { data } = await $app.axios.post('/services/notes/add_note', {
      note: {
        note_type: 'note',
        internal_view_only: true,
        notable_type: 'VacancyNotice',
        notable_id: record.id,
        text: message,
      },
    })

    await $app.axios.put(resource + '/defer_to', {
      [form_key]: {
        form_num: record.form_num,
        deferred_role: role,
      },
    })

    record.notes.push(data.note)

    Swal.fire(
      'Success!',
      `Application deferred! Message sent to ${role}`,
      'success'
    )
  } catch (error) {
    console.error(error)
    Swal.fire(
      'Oops...',
      'There has been an error with processing this request',
      'error'
    )
  }
}

async function upload (record) {
  const { value: upload } = await Swal.fire({
    icon: 'question',
    title: 'Upload OSH Report',
    input: 'file',
    inputLabel: 'Select A File To Upload',
    inputAttributes: { accept: 'application/pdf' },
    showCancelButton: true,
    confirmButtonText: 'Upload',
  })

  if (!upload) return
  this.setState({ loading: true })

  const form = new FormData()
  form.append('vacancy_notice[form_num]', record.form_num)
  form.append('vacancy_notice[osh_report_upload]', upload)

  try {
    await $app.axios.put(resource + '/update_upload', form)
    toastr.success('Success', 'Report successfully uploaded')
  } catch (error) {
    console.error(error)
    toastr.error('Error', 'Unable to upload OSH report')
  }

  this.setState({ loading: false })
}

async function submit (record) {
  const { props } = this
  const { history, location } = props
  const { axios } = $app

  try {
    await axios.put(resource + '/update_application', {
      [form_key]: {
        form_num: record.form_num,
        application_decision: 'processing',
      },
    })

    if (location?.state?.view) {
      const view = { ...location.state.view }
      view.application_decision = 'processing'

      history.replace(location.pathname, {
        ...location.state,
        view,
      })
    }

    Swal.fire(
      'Success!',
      'The application has been submitted to the Director for final approval',
      'success'
    )
  } catch (error) {
    console.error(error)
    Swal.fire(
      'Oops...',
      'There has been an error with processing your application',
      'error'
    )
  }
}

async function note (record) {
  const { value: message } = await Swal.fire({
    input: 'textarea',
    inputLabel: `Message to Director`,
    inputPlaceholder: 'Type your message here...',
    inputAttributes: {
      'aria-label': 'Type your message here',
    },
    showCancelButton: true,
    confirmButtonText: 'Send',
  })

  if (message) {
    try {
      const { data } = await $app.axios.post('/services/notes/add_note', {
        note: {
          note_type: 'note',
          internal_view_only: true,
          notable_type: 'VacancyNotice',
          notable_id: record.id,
          text: message,
        },
      })
      record.notes.push(data.note)
      console.log(data)
      Swal.fire('Success!', `Success! Message sent to Director`, 'success')
    } catch (error) {
      console.error(error)
      Swal.fire(
        'Oops...',
        'There has been an error with processing this request',
        'error'
      )
    }
  }
}
